/* eslint-disable react-refresh/only-export-components */
import { lazy, type ComponentType, type LazyExoticComponent } from "react";
import { routePaths } from "@config/routes";

export interface AppFeatureRoute {
  path: string;
  requireCompany?: boolean;
  Page: LazyExoticComponent<ComponentType>;
}

/** Add new screens here — one entry per route. */
export const appFeatureRoutes: AppFeatureRoute[] = [
  {
    path: routePaths.welcome,
    requireCompany: false,
    Page: lazy(() => import("@features/welcome").then((m) => ({ default: m.WelcomePage }))),
  },
  {
    path: routePaths.changePassword,
    requireCompany: false,
    Page: lazy(() => import("@features/auth").then((m) => ({ default: m.ChangePasswordPage }))),
  },
  {
    path: routePaths.userDetails,
    requireCompany: false,
    Page: lazy(() =>
      import("@features/User_Details").then((m) => ({ default: m.UserDetailsPage })),
    ),
  },
  {
    path: routePaths.userAccessLog,
    requireCompany: false,
    Page: lazy(() =>
      import("@features/UserAccessLog").then((m) => ({ default: m.UserAccessLogPage })),
    ),
  },
  {
    path: routePaths.bookClosureInfoForAll,
    requireCompany: false,
    Page: lazy(() =>
      import("@features/BookClosureInfoForAll").then((m) => ({ default: m.BookClosureInfoForAll })),
    ),
  },
  {
    path: routePaths.companyDetails,
    requireCompany: false,
    Page: lazy(() =>
      import("@features/Company_Details").then((m) => ({ default: m.CompanyDetailsPage })),
    ),
  },
  {
    path: routePaths.shareholdersWithPan,
    requireCompany: false,
    Page: lazy(() =>
      import("@features/ShareholderswithPan").then((m) => ({ default: m.ShareholdersWithPanPage })),
    ),
  },
  {
    path: routePaths.exportReports,
    requireCompany: false,
    Page: lazy(() =>
      import("@features/ExportReports").then((m) => ({ default: m.ExportReportsPage })),
    ),
  },
  {
    path: routePaths.shareHoldingOverView,
    requireCompany: false,
    Page: lazy(() =>
      import("@features/ShareholdingOverview").then((m) => ({
        default: m.ShareHoldingOverViewPage,
      })),
    ),
  },

  {
    path: routePaths.publicShareholding,
    requireCompany: false,
    Page: lazy(() =>
      import("@/features/PublicShareholding/component/PublicShareholding").then((m) => ({
        default: m.default,
      })),
    ),
  },
  {
    path: routePaths.NSDLCDSLCodes,
    requireCompany: false,
    Page: lazy(() =>
      import("@features/NSDLCDSLCodes").then((m) => ({
        default: m.default,
      })),
    ),
  },
  {
    path: routePaths.corporateAction,
    requireCompany: false,
    Page: lazy(() =>
      import("@features/CorporateAction").then((m) => ({ default: m.CorporateActionPage })),
    ),
  },
  {
    path: routePaths.companyEmployees,
    requireCompany: false,
    Page: lazy(() =>
      import("@features/CompanyEmployees").then((m) => ({
        default: m.CompanyEmployeesPage,
      })),
    ),
  },
  {
    path: routePaths.shHolding,
    requireCompany: false,
    Page: lazy(() =>
      import("@features/ShHolding").then((m) => ({
        default: m.ShHoldingPage,
      })),
    ),
  },
  {
    path: routePaths.agmAttendence,
    requireCompany: false,
    Page: lazy(() =>
      import("@features/Agm_Attendence/Components/AgmAttendence").then((m) => ({
        default: m.default,
      })),
    ),
  },
  {
    path: routePaths.companyAgmDetails,
    requireCompany: false,
    Page: lazy(() =>
      import("@features/Agm_Details/Components/CompanyAgmDetails").then((m) => ({
        default: m.default,
      })),
    ),
  },
  {
    path: routePaths.categoryUpdation,
    requireCompany: false,
    Page: lazy(() =>
      import("@features/CategoryUpdation/component/CategoryUpdation").then((m) => ({
        default: m.default,
      })),
    ),
  },
  {
    path: routePaths.dividendDetails,
    requireCompany: false,
    Page: lazy(() =>
      import("@features/Dividend_Details/component/DividendDetails").then((m) => ({
        default: m.default,
      })),
    ),
  },
  {
    path: routePaths.IEPFInfo,
    requireCompany: false,
    Page: lazy(() =>
      import("@features/IEPFInfo/component/IEPFInfo").then((m) => ({ default: m.default })),
    ),
  },
  {
    path: routePaths.sellersBuyersDifference,
    requireCompany: false,
    Page: lazy(() =>
      import("@features/SellersBuyersDifference").then((m) => ({
        default: m.SellersBuyersDifferencePage,
      })),
    ),
  },
  {
    path: routePaths.shareholdingPatternWithPan,
    requireCompany: false,
    Page: lazy(() =>
      import("@features/Share_holding_Pattern_WithPan/Component/ShareholdingPatternWithPan").then(
        (m) => ({ default: m.default }),
      ),
    ),
  },
  {
    path: routePaths.iepfShare,
    requireCompany: false,
    Page: lazy(() =>
      import("@features/IEPFShare/component/IEPFShare").then((m) => ({ default: m.default })),
    ),
  },
  {
    path: routePaths.search,
    requireCompany: false,
    Page: lazy(() =>
      import("@features/Search/component/Search").then((m) => ({ default: m.default })),
    ),
  },
  {
    path: routePaths.ShareholdingList,
    requireCompany: false,
    Page: lazy(() =>
      import("@/features/Shareholderslist/component/Shareholderslist").then((m) => ({
        default: m.default,
      })),
    ),
  },
  {
    path: routePaths.requestVerification,
    requireCompany: false,
    Page: lazy(() =>
      import("@features/RequestVerification/component/RequestVerification").then((m) => ({
        default: m.default,
      })),
    ),
  },
  {
    path: routePaths.transferBOHistory,
    requireCompany: false,
    Page: lazy(() =>
      import("@features/Transfer_BO_History/component/TransferBOHistory").then((m) => ({
        default: m.default,
      })),
    ),
  },
  {
    path: routePaths.iEPFYearWiseReport,
    requireCompany: false,
    Page: lazy(() =>
      import("@features/IEPFYearWiseReport/component/IEPFYearWiseReport").then((m) => ({
        default: m.default,
      })),
    ),
  },
  {
    path: routePaths.inwardDataVerification,
    requireCompany: false,
    Page: lazy(() =>
      import("@features/InwardDataVerification/component/InwardDataVerification").then((m) => ({
        default: m.default,
      })),
    ),
  },
  {
    path: routePaths.dividendInfo,
    requireCompany: false,
    Page: lazy(() =>
      import("@features/Dividend_Info/component/DividendInfo").then((m) => ({
        default: m.default,
      })),
    ),
  },
  {
    path: routePaths.bouncedEmailList,
    requireCompany: false,
    Page: lazy(() =>
      import("@features/Bounced_EmailList/component/BouncedEmailList").then((m) => ({
        default: m.default,
      })),
    ),
  },
  {
    path: routePaths.sebiScoresConsolidation,
    requireCompany: false,
    Page: lazy(() =>
      import("@features/SebiScoresConsolidation/component/SebiScoresConsolidation").then((m) => ({
        default: m.default,
      })),
    ),
  },
  {
    path: routePaths.sebiFYReport,
    requireCompany: false,
    Page: lazy(() =>
      import("@features/SebiFYReport/component/SebiFYReport").then((m) => ({
        default: m.default,
      })),
    ),
  },
  {
    path: routePaths.ReconciliationOverview,
    requireCompany: false,
    Page: lazy(() =>
      import("@features/Reconciliation_Overview/component/reconciliationOverview").then((m) => ({
        default: m.default,
      })),
    ),
  },

  {
    path: routePaths.isinHistories,
    requireCompany: false,
    Page: lazy(() =>
      import("@features/ISINHistories/component/ISINHistoriesPage").then((m) => ({
        default: m.default,
      })),
    ),
  },

  {
    path: routePaths.findYourShareHolder,
    requireCompany: false,
    Page: lazy(() =>
      import("@features/FindYourShareHolder/component/FindYourShareHolder").then((m) => ({
        default: m.default,
      })),
    ),
  },
  {
    path: routePaths.adminShareHoldingDetails,
    requireCompany: false,
    Page: lazy(() =>
      import("@features/AdminShareHoldingDetails/Component/AdminShareHoldingDetails").then((m) => ({
        default: m.default,
      })),
    ),
  },
  {
    path: routePaths.findYourShareHolder,
    requireCompany: false,
    Page: lazy(() =>
      import("@features/FindYourShareHolder/component/FindYourShareHolderPage").then((m) => ({
        default: m.default,
      })),
    ),
  },
  {
    path: routePaths.companyList,
    requireCompany: false,
    Page: lazy(() =>
      import("@features/CompanyList/component/CompanyList").then((m) => ({
        default: m.default,
      })),
    ),
  },
  {
    path: routePaths.quarterlysebiReport,
    requireCompany: false,
    Page: lazy(() =>
      import("@features/QuarterlySebiReport/component/QuarterlySebiReport").then((m) => ({
        default: m.default,
      })),
    ),
  },
  {
    path: routePaths.ReconciliationDetails,
    requireCompany: false,
    Page: lazy(() =>
      import("@features/Reconciliation_Details/component/ReconciliationDetails").then((m) => ({
        default: m.default,
      })),
    ),
  },
  {
    path: routePaths.BoHistory,
    requireCompany: false,
    Page: lazy(() =>
      import("@features/BOHistory/components/BOHistory").then((m) => ({ default: m.default })),
    ),
  },
  {
    path: routePaths.ShareholderDeclarationSearch,
    requireCompany: false,
    Page: lazy(() =>
      import("@features/ShareholderDeclarationSearch/component/ShareholderDeclarationSearch").then(
        (m) => ({ default: m.default }),
      ),
    ),
  },

  {
    path: routePaths.updateProcesss,
    requireCompany: false,
    Page: lazy(() =>
      import("@features/Update_Process/component/UpdateProcess").then((m) => ({
        default: m.default,
      })),
    ),
  },
  {
    path: routePaths.shareholdingOfPromoters,
    requireCompany: false,
    Page: lazy(() =>
      import("@features/ShareholdingOfPromoters/component/ShareholdingOfPromoters").then((m) => ({
        default: m.default,
      })),
    ),
  },
  {
    path: routePaths.shareHolderPatternOld,
    requireCompany: false,
    Page: lazy(() =>
      import("@features/ShareHolderPatternOld/component/ShareHolderPatternOld").then((m) => ({
        default: m.default,
      })),
    ),
  },
  {
    path: routePaths.CategoryWiseComparison,
    requireCompany: false,
    Page: lazy(() =>
      import("@features/CategoryWiseComparison/component/CategoryWiseComparison").then((m) => ({
        default: m.default,
      })),
    ),
  },
  {
    path: routePaths.Pas6,
    requireCompany: false,
    Page: lazy(() => import("@features/Pas6/component/Pas6").then((m) => ({ default: m.default }))),
  },
  {
    path: routePaths.distributionDetails,
    requireCompany: false,
    Page: lazy(() =>
      import("@features/DistributionDetails/component/DistributionDetails").then((m) => ({
        default: m.default,
      })),
    ),
  },
  {
    path: routePaths.promoterAndGroupDisclosures,
    requireCompany: false,
    Page: lazy(() =>
      import("@features/PromoterAndGroupDisclosures/component/PromoterAndGroupDisclosures").then(
        (m) => ({ default: m.default }),
      ),
    ),
  },
  {
    path: routePaths.promoterAndGroup,
    requireCompany: false,
    Page: lazy(() =>
      import("@features/Promoter&Group/component/PromoterAndGroupNew").then((m) => ({
        default: m.default,
      })),
    ),
  },
  {
    path: routePaths.report,
    requireCompany: false,
    Page: lazy(() =>
      import("@features/Report4/component/Report4").then((m) => ({ default: m.default })),
    ),
  },
  {
    path: routePaths.mailingList,
    requireCompany: false,
    Page: lazy(() =>
      import("@features/MailingList/component/MailingList").then((m) => ({ default: m.default })),
    ),
  },
  {
    path: routePaths.emailGeneral,
    requireCompany: false,
    Page: lazy(() =>
      import("@features/EmailGeneral/component/EmailGeneral").then((m) => ({ default: m.default })),
    ),
  },
  {
    path: routePaths.clientComunication,
    requireCompany: false,
    Page: lazy(() =>
      import("@features/ClientComunication/component/ClientComunication").then((m) => ({ default: m.default })),
    ),
  },
  {
    path: routePaths.categoryWiseSH,
    requireCompany: false,
    Page: lazy(() =>
      import("@features/CategoryWiseSH/component/CategoryWiseSH").then((m) => ({
        default: m.default,
      })),
    ),
  },
  {
    path: routePaths.pledgedShareholders,
    requireCompany: false,
    Page: lazy(() =>
      import("@features/PledgedShareholders/component/PledgedShareholders").then((m) => ({
        default: m.default,
      })),
    ),
  },
  {
    path: routePaths.remainderReport,
    requireCompany: false,
    Page: lazy(() =>
      import("@features/RemainderReport/component/RemainderReport").then((m) => ({
        default: m.default,
      })),
    ),
  },
  {
    path: routePaths.stopTransfer,
    requireCompany: false,
    Page: lazy(() =>
      import("@features/StopTransfer/component/StopTransfer").then((m) => ({ default: m.default })),
    ),
  },
  {
    path: routePaths.transferDetails,
    requireCompany: false,
    Page: lazy(() =>
      import("@features/TransferDetails/component/TransferDetails").then((m) => ({
        default: m.default,
      })),
    ),
  },
  {
    path: routePaths.shareholdingPatternNew,
    requireCompany: false,
    Page: lazy(() =>
      import("@features/ShareHoldingPatternNew/component/ShareHoldingPatternNew").then((m) => ({
        default: m.default,
      })),
    ),
  },
  {
    path: routePaths.Iepf4report,
    requireCompany: false,
    Page: lazy(() =>
      import("@features/IEPF4_Report/Component/IEPF4").then((m) => ({ default: m.default })),
    ),
  },
  {
    path: routePaths.masterUpdation,
    requireCompany: false,
    Page: lazy(() =>
      import("@features/MasterUpdation/component/MasterUpdation").then((m) => ({ default: m.default })),
    ),
  },
  {
    path: routePaths.ROCFiling,
    requireCompany: false,
    Page: lazy(() =>
      import("@features/ROC_Filing/component/ROCFiling").then((m) => ({ default: m.default })),
    ),
  },
  {
    path: routePaths.meaageTemplate,
    requireCompany: false,
    Page: lazy(() =>
      import("@features/MessageTemplate/Components/MessageTemplate").then((m) => ({ default: m.MessageTemplate })),
    ),
  },
  {
    path: routePaths.emailTemplate,
    requireCompany: false,
    Page: lazy(() =>
      import("@features/EmailTemplate/Component/EmailTemplate").then((m) => ({ default: m.default })),
    ),
  },
  {
    path: routePaths.deleteBenRecs,
    requireCompany: false, 
    Page: lazy(() =>
      import("@features/DeleteBenRecs/Components/DeleteBenRecs").then((m) => ({
        default: m.default,
      })),
    ),
  },
  {
    path: routePaths.queries,
    requireCompany: false, 
    Page: lazy(() => import('@features/Queries/components/Queries').then((m) => ({ default: m.default }))),
  },
  {
    path: routePaths.dividendRemainder,
    requireCompany: false,
    Page: lazy(() => import('@features/DividendRemainder/component/DividendRemainder').then((m) => ({ default: m.default }))),
  },
  {
    path: routePaths.InwardIntake,
    requireCompany: false,
    Page: lazy(() =>
      import("@features/InwardIntake/component/InwardIntake").then((m) => ({ default: m.default })),
    ),
  },
  {
    path: routePaths.approvedReport,
    requireCompany: false,
    Page: lazy(() => import('@features/Approved_Report/component/ApprovedReport').then((m) => ({ default: m.default }))),
  },
  {
    path: routePaths.dividendEmail,
    requireCompany: false,
    Page: lazy(() => import('@features/DividendEmail/component/DividendEmail').then((m) => ({ default: m.default }))),
  },
];

export const LoginPageLazy = lazy(() =>
  import("@features/auth").then((m) => ({ default: m.LoginPage })),
);
